module.exports = __webpack_public_path__ + "img/luck.289f0313.png";